// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NGzH","controls":"styles_controls__2tjPA","charLimit":"styles_charLimit__2uUhO","input":"styles_input__2zPXq","send":"styles_send__1tX-E"};